<template>
    <div>
        <select v-model="bot.first_name" @change="changeBot($event.target.value)" class="custom-form-control">
            <option v-for="(item,i) in bots" :value="item.first_name" :key="i">{{item.first_name}}</option>
        </select>
    </div>
</template>

<script>

export default {
    name: "BotDropDown",
    props:{
        bot: Object,
        bots: Array,
    },
    methods:{
        changeBot(name){
            let token = null
            this.bots.forEach(function(bot){
                if(bot.first_name == name){
                    token = bot.token
                }
            })
            if(token){
                this.$emit('change',token)
            }   
        },
    },
}
</script>

<style>
    .custom-form-control{
        display: block;
        width: 100%;
        padding: 0.75rem 1rem;
        font-size: 1rem; 
        line-height: 1.5;
        color: #fff;
        letter-spacing: 3px;
        background-color: #343a40;
        background-clip: padding-box;
        border: none;
        border-bottom: 1px solid #fff;
        border-top: 1px solid #fff;
        border-radius: 0;
        -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    }
    
</style>